import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["factoring.isDeletingFundingRequest"],
  payload => payload
);
